import { ProtectedRouteConfig, RouteConfig } from "../types/routes.types";
import { PERMISSIONS } from "@/utils/constant/global.constant";
import AccountVerifyPage from "../pages/public/AccountVerifyPage";
import LandingPage from "../pages/public/LandingPage";
import LoginPage from "../pages/public/LoginPage";
import MfaValidatePage from "../pages/public/MfaValidatePage";
import SignUpPage from "../pages/public/SignUpPage";
import ForgotPasswordPage from "../pages/public/ForgotPasswordPage";
import Setting from "@/pages/setting";
import DashboardLayout from "@/layouts/dashboard.layout";
import QATestingView from "@/components/internal/qa/QATestingView";
import QAPayload from "@/components/internal/qa/QAPayloadView";
import LoginHome from "@/pages/public/LoginHome";
import ResetPasswordPage from "@/pages/public/ResetPasswordPage";
import OrganizationProfile from "@/pages/organisationProfile";
import MyProfile from "@/pages/myProfile";
import { EmployeesPageWithModal } from "@/pages/employee/EmployeesPage";
import { EmployeeDetailsPageWithModal } from "@/pages/employee/EmployeeDetails";
import ShareDocument from "@/pages/shareDocs/ShareDocument";
import EmployeeTableLayout from "@/layouts/employeeTable.layout";
import { VerifyAccount } from "@/components/internal/product/VerifyAccount";
import { DashboardPageWithModal } from "@/pages/dashboard/DashboardPage";
import ImportHistory from "@/pages/employee/ImportHistory";
import { OrganizationsPageWithModal } from "@/pages/internal/OrganizationsPage";
import ViewLayout from "@/layouts/View.layout";
import ViewLayout2 from "@/layouts/View2.layout";
import PaymentHistoryPage from "@/pages/payment-history/PaymentHistoryPage";
import ExportHistoryPage from "@/pages/export-history/ExportHistoryPage";
import PaymentHistoryTableLayout from "@/layouts/paymentHistory.layout";

export const publicRoutes: RouteConfig[] = [
  { path: "/", element: <LandingPage /> },
  { path: "/login", element: <LoginHome /> },
  { path: "/login/:type", element: <LoginPage /> },
  { path: "/sign-up/:type", element: <SignUpPage /> },
  { path: "/verify-account", element: <AccountVerifyPage /> },
  { path: "/validate-mfa", element: <MfaValidatePage /> },
  { path: "/forgot-password/:type", element: <ForgotPasswordPage /> },
  { path: "/reset-password", element: <ResetPasswordPage /> },
  {
    path: "/share/:shareId",
    element: <ShareDocument />,
  },
];

export const internalRoutes: ProtectedRouteConfig[] = [
  {
    path: "/qa/generate-token",
    element: <QATestingView />,
    userTypes: ["INTL"],
    roles: ["QA"],
    permId: "qa-generate-token",
    Layout: DashboardLayout,
  },
  {
    path: "/qa/payload",
    element: <QAPayload />,
    userTypes: ["INTL"],
    roles: ["QA"],
    permId: "qa-payload",
    Layout: DashboardLayout,
  },
  {
    path: "/product/verify-account",
    element: <VerifyAccount />,
    userTypes: ["INTL"],
    roles: ["PRODUCT"],
    permId: "product-verify-account",
    Layout: DashboardLayout,
  },
  {
    path: "/internal/organizations",
    element: <OrganizationsPageWithModal />,
    userTypes: ["INTL"],
    roles: ["ALL"],
    permId: "all",
    Layout: DashboardLayout,
  },
];

export const protectedRoutes: ProtectedRouteConfig[] = [
  {
    path: "/dashboard",
    element: <DashboardPageWithModal />,
    userTypes: ["ALL"],
    roles: ["ALL"],
    notRoles: ["User"],
    permId: "all",
    Layout: DashboardLayout,
  },
  {
    path: "/home/employees/action/:modalName?/:employeeId?",
    element: <EmployeesPageWithModal />,
    userTypes: ["ORG"],
    roles: ["Account Owner", "Account Admin"],
    permId: [PERMISSIONS.EMPLOYEE["View Employees"], PERMISSIONS.EMPLOYEE["View Reporting Employee"]],
    Layout: EmployeeTableLayout,
  },
  {
    path: "/home/employees",
    element: <EmployeesPageWithModal />,
    userTypes: ["ORG"],
    roles: ["Account Owner", "Account Admin"],
    permId: [PERMISSIONS.EMPLOYEE["View Employees"], PERMISSIONS.EMPLOYEE["View Reporting Employee"]],
    Layout: EmployeeTableLayout,
  },
  {
    path: "/home/employees/:employeeId/:tab",
    element: <EmployeeDetailsPageWithModal />,
    userTypes: ["ORG"],
    roles: ["Account Owner", "Account Admin"],
    permId: [PERMISSIONS.EMPLOYEE["View Employees"], PERMISSIONS.EMPLOYEE["View Reporting Employee"]],
    Layout: ViewLayout,
  },
  {
    path: "/home/employment-details/:employeeId/:tab",
    element: <EmployeeDetailsPageWithModal isForEmploymentDetails />,
    userTypes: ["ORG"],
    roles: ["Account Owner", "Account Admin"],
    notRoles: ["Account Owner"],
    permId: PERMISSIONS.EMPLOYEE["View Own Employee"],
    Layout: ViewLayout,
  },
  {
    path: "/home/employees/import-history",
    element: <ImportHistory />,
    userTypes: ["ORG"],
    roles: ["Account Owner", "Account Admin"],
    permId: PERMISSIONS.EMPLOYEE["Import Employees"],
    Layout: DashboardLayout,     
  },
  {
    path: "/home/Payments-history",
    element: <PaymentHistoryPage />,
    userTypes: ["ORG"],
    roles: ["Account Owner", "Account Admin"],
    permId: PERMISSIONS.PAYMENT["View Payment History"],
    Layout: PaymentHistoryTableLayout,
  },
  {
    path: "/home/Payments-history/export-history",
    element: <ExportHistoryPage />,
    userTypes: ["ORG"],
    roles: ["Account Owner", "Account Admin"],
    permId: PERMISSIONS.PAYMENT["Export Payments"],
    Layout: PaymentHistoryTableLayout,
  },
  {
    path: "/home/settings/roles",
    element: <Setting.RolesPage />,
    userTypes: ["ORG"],
    roles: ["Account Owner", "Account Admin"],
    permId: PERMISSIONS.ROLES["View Roles"],
    notRoles: ["User"],
    Layout: ViewLayout,
  },
  {
    path: "/home/settings/roles/manage-permissions",
    element: <Setting.ManagePermissions />,
    userTypes: ["ORG"],
    roles: ["Account Owner", "Account Admin"],
    permId: PERMISSIONS.ROLES["Manage Permission"],
    notRoles: ["User"],
    Layout: ViewLayout2,
  },
  {
    path: "/home/settings",
    element: <Setting.SettingLandingPage />,
    userTypes: ["ORG", "VFR"],
    roles: ["Account Owner", "Account Admin"],
    permId: "all",
    notRoles: ["User"],
    Layout: DashboardLayout,
  },
  {
    path: "/home/settings/organization-profile",
    element: <Setting.OrganizationProfilePageWithModal />,
    userTypes: ["ORG", "VFR"],
    roles: ["Account Owner", "Account Admin"],
    permId: "all",
    Layout: DashboardLayout,
  },
  {
    path: "/home/settings/documents",
    element: <OrganizationProfile.DocumentsPageWithModal />,
    userTypes: ["ORG", "VFR"],
    roles: ["ALL"],
    permId: PERMISSIONS.SETTING["View Documents"],
    Layout: DashboardLayout,
  },
  {
    path: "/home/settings/signatory",
    element: <OrganizationProfile.SignatoryPageWithModal />,
    userTypes: ["ORG", "VFR"],
    roles: ["Account Owner", "Account Admin"],
    permId: PERMISSIONS.SETTING["View Signatory"],
    Layout: DashboardLayout,
  },
  {
    path: "/home/settings/letterhead",
    element: <OrganizationProfile.LetterHeadPageWithModal />,
    userTypes: ["ORG", "VFR"],
    roles: ["Account Owner", "Account Admin"],
    permId: PERMISSIONS.SETTING["View Letterhead"],
    Layout: DashboardLayout,
  },
  // Stand Alone Routes
  {
    path: "/home/profile",
    element: <MyProfile.ProfilePageWithModal />,
    userTypes: ["ALL"],
    roles: ["ALL"],
    permId: "all",
    Layout: DashboardLayout,
  },
  {
    path: "/home/documents",
    element: <OrganizationProfile.DocumentsPageWithModal />,
    userTypes: ["IDV"],
    roles: ["ALL"],
    permId: PERMISSIONS.SETTING["View Documents"],
    Layout: DashboardLayout,
  },
  {
    path: "/home/security",
    element: <MyProfile.SecurityPage />,
    userTypes: ["ALL"],
    roles: ["ALL"],
    permId: "all",
    Layout: DashboardLayout,
  },
  ...internalRoutes,
];
